import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { ActivityFeed } from '#admin/features/platform/activity/activity-feed.tsx'

/**
 * `/platform/tenants/$tenantId/activity` — what staff did to this edition. The edition's own
 * operators see the same acts in its audit log; this is the staff side of it.
 */
export const Route = createFileRoute('/_authenticated/platform/tenants/$tenantId/activity')({
  staticData: { crumb: 'Activity' },
  component: ActivityTab,
})

function ActivityTab() {
  const { tenantId } = Route.useParams()
  const [action, setAction] = useState('')
  return <ActivityFeed tenantId={tenantId} action={action} onActionChange={setAction} />
}
